import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "../../lib/arvi";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink(DEFAULT_WA_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with ARVI on WhatsApp"
      data-testid="floating-whatsapp-cta"
      className="fixed bottom-24 right-6 md:bottom-6 md:right-6 z-50 btn-cta-base bg-gold text-maroon hover:bg-maroon hover:text-ivory shadow-[0_18px_40px_-10px_rgba(67,9,21,0.45)] hover:-translate-y-[2px]"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2} />
      <span className="hidden sm:inline font-sans-body text-sm tracking-wide">
        Enquire on WhatsApp
      </span>
    </a>
  );
}
